 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import GROVEATLANTICLITHUB from '@/components/grove-atlantic-lithub'
 import LOVE_1 from '@/components/love_1'
 import A780802158017 from '@/components/9780802158017'
 import A7808021580171 from '@/components/9780802158017-1'
 import A7808021580172 from '@/components/9780802158017-2'
 import A7808021580173 from '@/components/9780802158017-3'
 import A7808021580174 from '@/components/9780802158017-4'
 import A7808021580175 from '@/components/9780802158017-5'
 import A7808021580176 from '@/components/9780802158017-6'
 import A7808021580177 from '@/components/9780802158017-7'
 import A7808021580178 from '@/components/9780802158017-8'
 import A7808021580179 from '@/components/9780802158017-9'
 import A78080215801710 from '@/components/9780802158017-10'
 import A78080215801711 from '@/components/9780802158017-11'
 import A78080215801712 from '@/components/9780802158017-12'
 import A78080215801713 from '@/components/9780802158017-13'
 import A78080215801714 from '@/components/9780802158017-14'
 import A78080215801715 from '@/components/9780802158017-15'
 import A78080215801716 from '@/components/9780802158017-16'
 import A78080215801717 from '@/components/9780802158017-17'
 import A78080215801718 from '@/components/9780802158017-18'
 import A78080215801719 from '@/components/9780802158017-19'
 import A78080215801720 from '@/components/9780802158017-20'
 import A78080215801721 from '@/components/9780802158017-21'
 import A78080215801722 from '@/components/9780802158017-22'
 import A78080215801723 from '@/components/9780802158017-23'
 import A78080215801724 from '@/components/9780802158017-24'
 import A78080215801725 from '@/components/9780802158017-25'
 import A78080215801726 from '@/components/9780802158017-26'
 import A78080215801727 from '@/components/9780802158017-27'
 import A78080215801728 from '@/components/9780802158017-28'
 import A78080215801729 from '@/components/9780802158017-29'
 import A78080215801730 from '@/components/9780802158017-30'
 import A78080215801731 from '@/components/9780802158017-31'
 import A78080215801732 from '@/components/9780802158017-32'
 import A78080215801733 from '@/components/9780802158017-33'
 import A78080215801734 from '@/components/9780802158017-34'
 import A78080215801735 from '@/components/9780802158017-35'
 import A78080215801736 from '@/components/9780802158017-36'
 import A78080215801737 from '@/components/9780802158017-37'
 import A78080215801738 from '@/components/9780802158017-38'
 import A78080215801739 from '@/components/9780802158017-39'
 import A78080215801740 from '@/components/9780802158017-40'
 import A78080215801741 from '@/components/9780802158017-41'
 import A78080215801742 from '@/components/9780802158017-42'
 import A78080215801743 from '@/components/9780802158017-43'
 import A78080215801744 from '@/components/9780802158017-44'
 import A78080215801745 from '@/components/9780802158017-45'
 import A78080215801746 from '@/components/9780802158017-46'
 import A78080215801747 from '@/components/9780802158017-47'
 import A78080215801748 from '@/components/9780802158017-48'
 import A78080215801749 from '@/components/9780802158017-49'
 import A78080215801750 from '@/components/9780802158017-50'
 import A78080215801751 from '@/components/9780802158017-51'
 import A78080215801752 from '@/components/9780802158017-52'
 import A78080215801753 from '@/components/9780802158017-53'
 import A78080215801754 from '@/components/9780802158017-54'
 import A78080215801755 from '@/components/9780802158017-55'
 import A78080215801756 from '@/components/9780802158017-56'
 import A78080215801757 from '@/components/9780802158017-57'
 import A78080215801758 from '@/components/9780802158017-58'
 import A78080215801759 from '@/components/9780802158017-59'
 import A78080215801760 from '@/components/9780802158017-60'
 import A78080215801761 from '@/components/9780802158017-61'
 import A78080215801762 from '@/components/9780802158017-62'
 import A78080215801763 from '@/components/9780802158017-63'
 import A78080215801764 from '@/components/9780802158017-64'
 import A78080215801765 from '@/components/9780802158017-65'
 import A78080215801766 from '@/components/9780802158017-66'
 import A78080215801767 from '@/components/9780802158017-67'
 import A78080215801768 from '@/components/9780802158017-68'
 import A78080215801769 from '@/components/9780802158017-69'
 import A78080215801770 from '@/components/9780802158017-70'
 import A78080215801771 from '@/components/9780802158017-71'
 import A78080215801772 from '@/components/9780802158017-72'
 import A78080215801773 from '@/components/9780802158017-73'
 import A78080215801774 from '@/components/9780802158017-74'
 import A78080215801775 from '@/components/9780802158017-75'
 import A78080215801776 from '@/components/9780802158017-76'
 import LOVE_2 from '@/components/love_2'
 import A78080215801777 from '@/components/9780802158017-77'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/grove-atlantic-lithub",
 			"name" : "grove-atlantic-lithub",
 			"component" : GROVEATLANTICLITHUB
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/9780802158017",
 			"name" : "9780802158017",
 			"component" : A780802158017
 		},
 		{
 			"path" : "/9780802158017-1",
 			"name" : "9780802158017-1",
 			"component" : A7808021580171
 		},
 		{
 			"path" : "/9780802158017-2",
 			"name" : "9780802158017-2",
 			"component" : A7808021580172
 		},
 		{
 			"path" : "/9780802158017-3",
 			"name" : "9780802158017-3",
 			"component" : A7808021580173
 		},
 		{
 			"path" : "/9780802158017-4",
 			"name" : "9780802158017-4",
 			"component" : A7808021580174
 		},
 		{
 			"path" : "/9780802158017-5",
 			"name" : "9780802158017-5",
 			"component" : A7808021580175
 		},
 		{
 			"path" : "/9780802158017-6",
 			"name" : "9780802158017-6",
 			"component" : A7808021580176
 		},
 		{
 			"path" : "/9780802158017-7",
 			"name" : "9780802158017-7",
 			"component" : A7808021580177
 		},
 		{
 			"path" : "/9780802158017-8",
 			"name" : "9780802158017-8",
 			"component" : A7808021580178
 		},
 		{
 			"path" : "/9780802158017-9",
 			"name" : "9780802158017-9",
 			"component" : A7808021580179
 		},
 		{
 			"path" : "/9780802158017-10",
 			"name" : "9780802158017-10",
 			"component" : A78080215801710
 		},
 		{
 			"path" : "/9780802158017-11",
 			"name" : "9780802158017-11",
 			"component" : A78080215801711
 		},
 		{
 			"path" : "/9780802158017-12",
 			"name" : "9780802158017-12",
 			"component" : A78080215801712
 		},
 		{
 			"path" : "/9780802158017-13",
 			"name" : "9780802158017-13",
 			"component" : A78080215801713
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js